import { Editor } from '@tinymce/tinymce-react';
import { TINY_MCE_TOKEN } from '../../config/appConfig';

export const CkRichEditor = ({
	value,
	onChange = (data) => { },
	onClick = (e, editor) => { },
	isArabic = false,
}) => {
	return (
		<Editor
			apiKey={TINY_MCE_TOKEN}
			onClick={(e, editor) => { onClick && onClick(e, editor); }}
			onBlur={(e, editor) => {
				onChange && onChange(editor.getContent());
			}}
			init={{
				content_style: 'p {margin:0} pre {margin:0} h1 {margin:0} h2 {margin:0} h3 {margin:0} h4 {margin:0} h5 {margin:0} h6 {margin:0} body { font-family: "Montserrat", "Helvetica", sans-serif; }',
				height: 500,
				toolbar_mode: 'sliding',
				directionality: isArabic ? 'rtl' : 'ltr',
				plugins:
					'code preview anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
				toolbar:
					'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
				font_family_formats: 'Montserrat="Montserrat", "Helvetica", sans-serif;' +
					'Andale Mono=andale mono,times;' +
					'Arial=arial,helvetica,sans-serif;' +
					'Arial Black=arial black,avant garde;' +
					'Book Antiqua=book antiqua,palatino;' +
					'Comic Sans MS=comic sans ms,sans-serif;' +
					'Courier New=courier new,courier;' +
					'Georgia=georgia,palatino;' +
					'Helvetica=helvetica;' +
					'Impact=impact,chicago;' +
					'Symbol=symbol;' +
					'Tahoma=tahoma,arial,helvetica,sans-serif;' +
					'Terminal=terminal,monaco;' +
					'Times New Roman=times new roman,times;' +
					'Trebuchet MS=trebuchet ms,geneva;' +
					'Verdana=verdana,geneva;' +
					'Webdings=webdings;' +
					'Wingdings=wingdings,zapf dingbats;',
			}}
			initialValue={value}
		/>
	);
};
